module.exports = __webpack_public_path__ + "img/TSLA.267a4a61.png";